import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { PRIVATE_LISTER } from './utils/const';
import agentType from './props/agent-type';
import * as styles from './carousel-agent-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PrivateListerCard = _ref => {
  var agent = _ref.agent;
  return ___EmotionJSX("div", {
    key: agent.name,
    css: styles.agent
  }, ___EmotionJSX(Avatar, {
    css: styles.avatar,
    size: "custom",
    theme: "allhomes"
  }), ___EmotionJSX("p", {
    css: styles.name
  }, agent.name), ___EmotionJSX("p", {
    css: styles.agency
  }, PRIVATE_LISTER));
};
PrivateListerCard.propTypes = {
  agent: PropTypes.shape(agentType)
};
PrivateListerCard.defaultProps = {
  agent: {
    name: PRIVATE_LISTER
  }
};
export default PrivateListerCard;